import React from 'react';
import { useState } from 'react';
import RecipeInstructions from "../../RecipeInstructions/RecipeInstructions"
import RecipeIngredients from "../../RecipeIngredients/RecipeIngredients";

function RecipeActiveElement({ recipe, handleDelete, handleEditing }) {
    const [instructionsVisible, setInstructionsVisible] = useState(false)

    function handleEdit() {
        handleEditing(recipe)
    }
            
    return (
        <div className="recipe-list-element-container" >
            <div className="recipe-list-data-container recipe-element column" style={{ whiteSpace: 'pre-wrap'}} >
                <p>{recipe.Recipe_Name}:</p>
                <p>Time: {recipe.Recipe_Time}m                 Difficulty: {recipe.Recipe_Difficulty}/10</p>
                <RecipeIngredients Recipe_Ingredients={recipe.Recipe_Ingredients} ingredientsVisible={true} isActive={true} />
                <button className="show-instructions button" onClick={() => setInstructionsVisible(!instructionsVisible)} > {instructionsVisible ? "Hide Recipe Instructions" : "See Recipe Instructions"} </button>
                <RecipeInstructions inputInstructions={recipe.Recipe_Instructions} showInstructions={instructionsVisible} />
                <div className="recipe delete-edit-button-container row">
                    <button className="button" onClick={() => handleDelete(recipe)} > Delete </button>
                    <button className="button" onClick={() => handleEdit(recipe)} > Edit </button>
                </div>
            </div>
        </div>
    )
}

export default RecipeActiveElement;